module.exports = __webpack_public_path__ + "media/images/haircut/main_image2@3x-c9b4bc98aa9b1cf5722a8fb92f3d8a0b.jpg";